export const parseGoodreadsCSV = (csvText) => {
  const lines = csvText.split('\n');
  const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
  
  const books = [];

  // Helper to safely split CSV line respecting quotes
  const splitCSV = (str) => {
    const result = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    result.push(current.trim());
    return result;
  };

  for (let i = 1; i < lines.length; i++) {
    if (!lines[i].trim()) continue;
    
    const row = splitCSV(lines[i]);
    const book = {};
    
    headers.forEach((header, index) => {
      book[header] = row[index]?.replace(/^"|"$/g, '') || ''; // Remove surrounding quotes
    });

    if (book['Title']) {
      // Map Status
      let status = 'TBR';
      const shelf = book['Exclusive Shelf'] || book['Shelves'] || '';
      if (shelf.includes('read')) status = 'Read';
      if (shelf.includes('currently-reading')) status = 'Reading';
      if (shelf.includes('to-read')) status = 'TBR';

      // Map Cover (Try ISBN)
      const isbn = book['ISBN13']?.replace(/[^0-9]/g, '') || book['ISBN']?.replace(/[^0-9]/g, '');
      const cover = isbn ? `https://covers.openlibrary.org/b/isbn/${isbn}-M.jpg` : null;

      books.push({
        title: book['Title'],
        author: book['Author'],
        status: status,
        rating: parseInt(book['My Rating']) || 0,
        cover: cover
      });
    }
  }

  return books;
};
